import ApiService from "@/services/api.service";
import JwtService from "@/services/jwt.service";
import UsersService from "@/services/modules/users.service";

const getUser = async ({ commit }) => {
    const response = UsersService.getUserByToken();

    response.then(function (_data) {
        commit("login", _data.user);

        JwtService.setBranch(_data.user.branch_id);
        ApiService.setupHeaders();
    });

    return response;
};

const login = async ({ commit }, _credential) => {
    const response = UsersService.login(
            _credential.username,
            _credential.password
            );

    response.then(function (_data) {
        JwtService.saveToken(_data.token);

        ApiService.init();
    });

    return response;
};

const logout = async ({ commit }) => {
    JwtService.destroyToken();

    commit("logout");
};

const getPermissions = async ({commit}, _userId) => {
    const response = UsersService.getPermissionsById(_userId);

    response.then(function (_data) {
        commit("setPermissions", _data);
    });

    return response;
};

const refreshToken = async () => {
    const response = UsersService.refreshToken();

    response.then(function (_data) {
        JwtService.saveToken(_data.token);

        ApiService.init();
    });

    return response;
};

const socialLogin = async ({ commit }, _firebaseToken) => {
    const response = UsersService.socialLogin(_firebaseToken);

    response.then(function (_data) {
        JwtService.saveToken(_data.token);

        ApiService.init();
    });

    return response;
};

const socialRegister = async ({ commit }, _userRegister) => {
    const response = UsersService.register(
            _userRegister.displayName,
            _userRegister.email,
            _userRegister.uid,
            _userRegister.uid,
            _userRegister.uid
            );

    response.then(function (_data) {
        JwtService.saveToken(_data.token);

        ApiService.init();
    });

    return response;
};

export default {
    getUser,
    getPermissions,
    login,
    logout,
    refreshToken,
    socialLogin,
    socialRegister
};
